import { type AxiosError } from 'axios';

/**
 * Centralizziamo alcune logice necessarie per la gestione
 * del salvataggio in due step.
 * (Richiesta conferma per moduli dinamici)
 */
export class ConfirmUpdateLogic {
  /**
   * Le API ritornano error 406 Not Acceptable quando ci sono state
   * delle modifiche che richiedono una conferma da parte dell'utente.
   */
  static needUserConfirm(error: AxiosError) {
    return error.response?.status === 406;
  }
}
